import { NgModule } from '@angular/core';
import { TtNouisliderComponent } from './tt-nouislider.component';

@NgModule({
    exports: [TtNouisliderComponent],
    imports: [TtNouisliderComponent],
})
export class TtNouisliderModule { }
